import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from "vue";
import Highcharts, { PointOptionsObject } from "highcharts";
import { Chart } from "highcharts-vue";
import { formatter } from "@/shared/ts/formatter";


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawdownChart',
  props: {
    title: { type: String, default: "Pension Drawdown" },
    chartData: { type: Array as PropType<PointOptionsObject[]>, required: true },
    legendEnabled: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;

function getChartOptions() {
  let ctx = this,
    chartConfig: Highcharts.Options = {
      chart: {
        type: "column",
        height: 380,
      },
      plotOptions: {
        column: {
          pointPadding: -0.1,
          borderWidth: 1,
          borderColor: 'gray',
          shadow: false,
          borderRadius: 0,
          dataLabels: {
            enabled: false,
            color: "black"
          },
          pointStart: 1
        }
      },
      title: {
        text: props.title,
        style: {
          color: "#5c5b5b",
          fontWeight: "600",
          fontSize: "13px"
        }
      },
      xAxis: {
        title: {
          text: 'Retirement Year',
          style: {
            color: "#5c5b5b",
            fontSize: "12px"
          }
        },
        allowDecimals: false,
        tickInterval: 1
      },
      yAxis: {
        title: {
          text: null
        },
        labels: {
          formatter: function(this: Highcharts.AxisLabelsFormatterContextObject): string {
            const number = Number(this.value) / 1000;
            const formatted = Highcharts.numberFormat(number, 0, ".", ",");
            return `£${formatted}k`;
          }
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        backgroundColor: "white",
        borderWidth: 1,
        borderRadius: 3,
        shadow: false,
        formatter: function(
          this: Highcharts.Point
        ): string {
          return (`<b>Retirement Year ${this.x}</b><br/>${this.series.name}: ${formatter.formatCurrency(this.y)}`);
        }
      },
      series: [
        {
          type: "column",
          name: "Total to Take from Pensions",
          data: props.chartData
        }
      ],
      credits: {
        enabled: false
      }
    };

  return chartConfig;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Chart), {
      options: getChartOptions()
    }, null, 8, ["options"])
  ]))
}
}

})